import WorksHeader from "./WorkHeader";

function withWorks(Component: any) {
  return function render(props: any) {
    return <WorksHeader>{<Component {...props} />}</WorksHeader>;
  };
}

export default withWorks;
